import styled from "styled-components";

export const BulkAssignmentPanel = styled.div`
    background: #f9fafc;
    border-top: 1px solid #dbe5ed;
    border-bottom: 1px solid #dbe5ed;
    margin: 1.5rem -1.875rem 0 -3.75rem;
    overflow: hidden;
`;

export const BulkSelectedStrip = styled.div`
    align-items: center;
    display: flex;
    gap: 1.5rem;
    padding: 1rem 3.75rem;
`;

export const SelectedUsersLabel = styled.div`
    color: #4b5155;
    font-size: 1rem;
    font-weight: 700;
`;

export const SelectedUsersCard = styled.div`
    align-items: center;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 15px;
    box-shadow: 0 5px 5px #0000001a;
    display: flex;
    gap: 0.75rem;
    min-width: 11.5rem;
    height: 59px;
    padding: 0 1rem;
`;

export const SelectedUsersIcon = styled.div`
    align-items: center;
    background: #d6d6d6;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 3px 6px #00000029;
    display: flex;
    height: 2.25rem;
    justify-content: center;
    width: 2.25rem;
`;

export const BulkUserSection = styled.div`
    border-top: 1px solid #dbe5ed;
    padding: 1.5rem 3.75rem 2rem;
`;

export const BulkUserSectionHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
`;

export const BulkUserSectionTitle = styled.div`
    color: #4b5155;
    font-size: 1rem;
    font-weight: 700;
`;

export const BulkAssignedCount = styled.div`
    color: #11141a;
    font-size: 1rem;
    font-weight: 700;
`;

export const BulkUserControls = styled.div`
    align-items: center;
    display: flex;
    gap: 4rem;
    justify-content: space-between;
    margin-bottom: 1rem;
`;

export const BulkSearchWrapper = styled.div`
    max-width: 27rem;
    position: relative;
    width: 100%;

    img {
        height: 1.25rem;
        position: absolute;
        right: 1rem;
        top: 0.65rem;
        width: 1.25rem;
    }
`;

export const BulkSearchInput = styled.input`
    background: #fff;
    border: 1px solid #dbe5ed;
    border-radius: 0.5rem;
    box-sizing: border-box;
    color: #11141a;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    height: 2.5rem;
    outline: none;
    padding: 0 3rem 0 1rem;
    width: 100%;

    ::placeholder {
        color: #afbbc6;
    }
`;

export const AllUsersToggle = styled.div`
    align-items: center;
    background: #fff;
    border: 1px solid #dbe5ed;
    border-radius: 0.5rem;
    display: flex;
    height: 2.5rem;
    justify-content: space-between;
    max-width: 16rem;
    min-width: 13rem;
    padding: 0 0.75rem 0 1rem;
    width: 100%;

    span {
        color: #11141a;
        font-size: 0.875rem;
        font-weight: 700;
    }
`;

export const BulkUsersTableContainer = styled.div`
    border: 1px solid #dbe5ed;
    border-radius: 0.5rem;
    max-height: 24.5rem;
    overflow: auto;

    ::-webkit-scrollbar {
        height: 0.375rem;
        width: 0.375rem;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #dbe5ed;
        border-radius: 0.375rem;
    }
`;

export const BulkUsersTable = styled.table`
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
`;

export const BulkUsersTH = styled.th`
    background: #f9fafc;
    color: #4b5155;
    font-size: 0.875rem;
    font-weight: 700;
    padding: 0.75rem 1rem;
    text-align: left;
`;

export const BulkUsersTD = styled.td`
    background: #fff;
    border-top: 1px solid #dbe5ed;
    color: #11141a;
    font-size: 0.875rem;
    font-weight: 700;
    height: 3.875rem;
    padding: 0.5rem 1rem;
    vertical-align: middle;
`;

export const BulkUserNameCell = styled.div`
    align-items: center;
    display: flex;
    gap: 1rem;
    min-width: 0;
`;

export const BulkUserAvatar = styled.div`
    align-items: center;
    background: #d9d9d9;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 3px 6px #00000029;
    color: #6f6f6f;
    display: flex;
    flex: 0 0 auto;
    font-size: 0.875rem;
    font-weight: 700;
    height: 2.5rem;
    justify-content: center;
    width: 2.5rem;
`;

export const BulkUserName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const BulkAssignButton = styled.button`
    align-items: center;
    background: ${p => p.$checked ? "#1a61ff" : "#fff"};
    border: ${p => p.$checked ? "none" : "1px solid #11141a"};
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 1.625rem;
    justify-content: center;
    margin: 0 auto;
    padding: 0;
    width: 1.625rem;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }

    img {
        height: 1.625rem;
        width: 1.625rem;
    }
`;

export const EmptyBulkUsers = styled.div`
    background: #fff;
    border-top: 1px solid #dbe5ed;
    color: #626262;
    font-size: 0.875rem;
    padding: 1rem;
`;

export { BulkSectionDivider, BulkSectionHeader, BulkSectionTitle, BulkSectionDescription }
    from "src/components/DefaultPermissionAssignmentStyles";
